import dashboard from "@/views/dashboard/index";

export default [
  {
    path: "/dictionariesType",
    name: "dictionariesType",
    component: dashboard,
    redirect: {
      name: "brandTypeIndex"
    },
    children: [
      {
        path: "brandTypeIndex",
        name: "brandTypeIndex",
        meta: { title: "媒体分类" },
        component: () => import("@/views/brandType/index.vue"),
        children: [
          {
            path: "addBrandType",
            name: "addBrandType",
            meta: { title: "添加品牌" },
            component: () => import("@/views/brandType/addBrandType.vue")
          },
          {
            path: "addCategoryType",
            name: "addCategoryType",
            meta: { title: "添加品类" },
            component: () => import("@/views/brandType/addCategory.vue")
          },
          {
            path: "editBrandTypeInfo/:brandId",
            name: "editBrandTypeInfo",
            meta: { title: "修改品牌" },
            component: () => import("@/views/brandType/brandTypeManage.vue")
          },
          {
            path: "editCategoryTypeInfo/:brandId",
            name: "editCategoryTypeInfo",
            meta: { title: "修改品类" },
            component: () => import("@/views/brandType/categoryManage.vue")
          }
        ]
      }
    ]
  }
];
